import { PokerGoalsScreen } from '@/screens/name-screen/PokerGoalsScreen'

export default function () {
  return <PokerGoalsScreen />
}
